<template>
    <q-tooltip v-if="isVisible" ref="tooltip" :delay="delay" v-bind="$attrs" class="CustomQTooltip"><slot /></q-tooltip>
</template>

<script setup lang="ts">
import { useIsActivated } from '@platform/shared/hooks/use-is-activated';
import { QTooltip } from 'quasar';
import { onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';

interface MyTooltipProps {
    delay?: number;
}

const props = withDefaults(defineProps<MyTooltipProps>(), {
    delay: 1000,
});

const isVisible = useIsActivated();

const tooltip = ref<QTooltip>();
const route = useRoute();
watch(
    () => route.fullPath,
    () => tooltip.value?.hide()
);
watch(isVisible, (value) => {
    if (!value) {
        tooltip.value?.hide();
    }
});

const hideTooltip = () => {
    tooltip.value?.hide();
};

onMounted(() => {
    window.addEventListener('platform:hide-tooltips', hideTooltip);
});

onBeforeUnmount(() => {
    window.removeEventListener('platform:hide-tooltips', hideTooltip);
    tooltip.value?.hide();
});
</script>
